import { AxiosResponse } from "axios";
import { put, takeLeading } from "redux-saga/effects";
import { Urls } from "src/constants";
import { HttpService, SeoService } from "src/services";
import { PagesAction } from "../actions";
import { PagesType } from "../types";

export function* PagesSaga() {
    yield takeLeading(PagesType.REQUEST_ABOUT_US_CONTENT, requestAboutUs);
    yield takeLeading(PagesType.REQUEST_PACKAGE_GUIDE_CONTENT, requestPackageGuide);
    yield takeLeading(PagesType.REQUEST_APP_LINKS_CONTENT, requestAppLinks);
}


function* requestAboutUs() {

    try {
        const api = Urls.content.aboutUs();
        const response: AxiosResponse = yield HttpService.Fetch(api);

        if (response.data) {
            yield put(PagesAction.setAboutUs(response.data));
            SeoService.setHeaderMetadata(response.data.title);
        }
    }
    catch {
        const mock = {
            loaded: false,
            uniqueKey: "about_us",
            title: "درباره ما",
            htmlBody: "<p>آنتن؛ اپلیکیشن تماشای برخط رویدادها و رقابت‌های ورزشی و مسابقات فوتبال لیگ های معتبر فوتبال</p><p>ویژگی ها:</p><ul><li>سرعت بالا در پخش ویدیوها</li><li>آرشیو و لیست پخش برنامه ها</li><li>امکان مشاهده برنامه های گذشته</li><li>امکان جستجو در برنامه ها و همچنین دانلود ویدیو</li></ul>"
        };
        yield put(PagesAction.setAboutUs(mock));
    }
}

function* requestPackageGuide() {

    try {
        const api = Urls.content.packageGuide();
        const response: AxiosResponse = yield HttpService.Fetch(api);

        if (response.data) {
            yield put(PagesAction.setPackageGuide(response.data));
            SeoService.setHeaderMetadata(response.data.title);
        }
    }
    catch {
        const mock = {
            loaded: false,
            uniqueKey: "package_guide",
            title: "راهنمای خرید اشتراک",
            htmlBody: ""
        };
        yield put(PagesAction.setPackageGuide(mock));
    }
}

function* requestAppLinks() {

    try {
        const api = Urls.content.apps();
        const response: AxiosResponse = yield HttpService.Fetch(api);

        if (response.data) {
            yield put(PagesAction.setAppLinks(response.data));
        }
    }
    catch {
        yield put(PagesAction.setAppLinks({
            android: [],
            ios: [],
            tv: []
        }));
    }
}